var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"stroke":"#FFA500","fill":"none","aria-hidden":"true","role":"img","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }